import { selectMerchant } from "@redux";
import { Skeleton } from "antd";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ImageUploadIcon } from "src/Components/icon";
import { StyledUploadImageBox } from "./UploadImageBoxStyled";

interface IProps {
    isLoading: boolean;
    handleChangeImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
    image: string;
    color?: string;
}

const tkey = "page.uploadActivity";
export const UploadImageBox = ({ isLoading, handleChangeImage, image, color }: IProps) => {
    //page redux
    const { themes } = useSelector(selectMerchant);
    // REF
    const inputRef = useRef();
    // Translation
    const { t } = useTranslation("translation", { keyPrefix: tkey });

    return (
        <Skeleton loading={isLoading} active title={true} paragraph={{ rows: 1, width: [100] }}>
            <input
                //@ts-ignore
                ref={inputRef}
                type="file"
                hidden
                id="uploadImage"
                onChange={handleChangeImage}
                accept="image/png, image/jpeg, image/jpg"
            />
            <StyledUploadImageBox themeColor={themes?.themeColor!} campaignColor={color}>
                {!image ? (
                    <div className="dont-have-img">
                        <label className="camera-text" htmlFor="uploadImage">
                            <ImageUploadIcon color={themes?.themeColor || "#76C0D9"} />
                            <p>{t("uploadLabel")}</p>
                        </label>
                    </div>
                ) : (
                    <div className="have-img">
                        <label className="camera-text" htmlFor="uploadImage">
                            <img src={image} />
                        </label>
                    </div>
                )}
            </StyledUploadImageBox>
        </Skeleton>
    );
};
